import { container, title } from "assets/jss/material-kit-react.jsx";

const parallaxStyle = {
  container: {
    ...container,
    zIndex: "12",
    color: "#f8f8ff",
    paddingLeft: "30px",
    paddingTop: "50px",
    "&:before": {
      background: "linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))",
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "11",
      width: "100%",
      height: "10%",
      display: "block",
      content: "''",
      top: "0",
      left: "0"
    },
  },
  parallax: {
    height: "100vh",
    width: "100%",
    maxHeight: "1000px",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center",
    textShadow: "1px 1px 2px black",
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.4)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  small: {
    height: "380px"
  },
};

export default parallaxStyle;
